import { render, staticRenderFns } from "./economyNews.vue?vue&type=template&id=b4005c7e&scoped=true"
import script from "./economyNews.vue?vue&type=script&lang=js"
export * from "./economyNews.vue?vue&type=script&lang=js"
import style0 from "./economyNews.vue?vue&type=style&index=0&id=b4005c7e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4005c7e",
  null
  
)

export default component.exports